// root state object.
// each Vuex instance is just a single state tree.
const state = {
    videoSubtitlesId   : 1,
    videoSubtitlesList : [],
    showSubtitleForm: false,
    currentMode: false
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {

    toggleAddSubtitleForm (state) {
        state.showSubtitleForm = !state.showSubtitleForm;
    },
    closeSubtitleForm (state) {
        state.showSubtitleForm = false;
    },
    changeCurrentMode (state) {
        state.showSubtitleForm = false;
        state.currentMode = !state.currentMode;
    },
    /**
     * TODO
     *
     * @function   incrementVideoSubtitlesId
     * @param      {Object} state
     */
    incrementVideoSubtitlesId (state) {
        state.videoSubtitlesId++;
    },
    /**
     * Add video to selected list
     *
     * @function   addVideoSubtitle
     */
    addVideoSubtitle (state, subtitle) {
        /* close other subtitles el */
        state.videoSubtitlesList.forEach(function (element) {
            if (element.showHideEdit) {
                element.showHideEdit = false;
            }
        });

        /* add the new subtitle to the list */
        subtitle.id = state.videoSubtitlesId++;
        state.videoSubtitlesList.push(subtitle);
        // TODO add controll duplicated time
    },
    /**
     *
     */
    editVideoSubtitle (state, subtitle) {
        state.videoSubtitlesList.forEach(function (element) {
            if (element.id === subtitle.id) {
                element.content = subtitle.content;
            }
        });
    },
    /**
     * Change the content of the selected videos list
     *
     * @function   updateVideoSubtitle
     */
    updateVideoSubtitle (state, videoSubtitles) {
        state.videoSubtitlesList = videoSubtitles;
    },
    /**
     * Delete the content of selectedVideosList
     *
     * @function   clearVideoSubtitlesList
     */
    clearVideoSubtitlesList (state) {
        state.videoSubtitlesList = [];
    },
    /**
     *
     */
    closeAllEditPanel (state) {
        state.videoSubtitlesList.forEach(function (element) {
            if (element.showHideEdit) {
                element.showHideEdit = false;
            }
        })
    },
    /**
     *
     */
    setCurrentSubtitle(state, id) {
        state.videoSubtitlesList.forEach(function (element) {
            if (element.id === id) {
                element.showHideEdit = true;
            } else {
                element.showHideEdit = false;
            }
        })
    },
    /**
     *
     */
    deleteSubtitleById (state, id) {
        state.videoSubtitlesList = state.videoSubtitlesList.filter(function (subtitle) {
            return subtitle.id !== id;
        })
    },
    incrementStartTime (state, subtitle) {
        subtitle.start++;
    },
    decrementStartTime (state, subtitle) {
        subtitle.start--;
    },
    incrementEndTime (state, subtitle) {
        subtitle.end++;
    },
    decrementEndTime (state, subtitle) {
        subtitle.end--;
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    incrementVideoSubtitlesId: ({ commit }) => commit('incrementVideoSubtitlesId'),
    addVideoSubtitle: ({ state, commit }, subtitle) => commit('addVideoSubtitle', subtitle),
    editVideoSubtitle: ({ state, commit }, subtitle) => commit('editVideoSubtitle', subtitle),
    updateVideoSubtitle: ({ state, commit }, videoSubtitles) => commit('updateVideoSubtitle', videoSubtitles),
    clearVideoSubtitlesList: ({ commit }) => commit('clearVideoSubtitlesList'),
    closeAllEditPanel: ({ commit }) => commit('closeAllEditPanel'),
    toggleAddSubtitleForm: ({ commit }) => commit('toggleAddSubtitleForm'),
    closeSubtitleForm: ({ commit }) => commit('closeSubtitleForm'),
    changeCurrentMode: ({ commit }) => commit('changeCurrentMode'),
    setCurrentSubtitle: ({ state, commit }, id) => commit('setCurrentSubtitle', id),
    deleteSubtitleById: ({ state, commit }, id) => commit('deleteSubtitleById', id),
    incrementStartTime: ({ state, commit }, subtitle) => commit('incrementStartTime', subtitle),
    decrementStartTime: ({ state, commit }, subtitle) => commit('decrementStartTime', subtitle),
    incrementEndTime: ({ state, commit }, subtitle) => commit('incrementEndTime', subtitle),
    decrementEndTime: ({ state, commit }, subtitle) => commit('decrementEndTime', subtitle),
};

// getters are functions
const getters = {
    /**
     * Get getVideoSubtitlesList
     */
    getVideoSubtitlesList:  state => state.videoSubtitlesList,
    /**
     * Get getVideoSubtitlesId
     */
    getVideoSubtitlesId:  state => state.videoSubtitlesId,
    /**
     * Get getShowSubtitleForm
     */
    getShowSubtitleForm:  state => state.showSubtitleForm,
    /**
     * Get getCurrentMode
     */
    getCurrentMode:  state => state.currentMode
};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./demo/store/modules/video-subtitles.js